<template>
  <div class="detail-wrapper" v-show="loadingPageOver" :style="iosOrAndroidStyle">
    <w-loading v-if="loadingShow"/>
    <div v-else>
      <w-nav-bar nav_title="职位详情" @mobileLeftBtn="toBack" v-show="iosOrAndroidShow"
                 :icon="isWxMini && needShare ? '' : 'iconchevron-left'"/>
      <div class="container">
        <div class="container-top">
          <div class="title">{{response.comp_recruit_info && response.comp_recruit_info.comp_name}}</div>
          <div class="header-content">
            <div class="company-left">
              <div class="cities">
                <span class="iconfont iconmap-pin"/>
                <span v-for="city in response.city_names" :key="city" class="city">{{city}}</span>
              </div>
              <div class="desc">
                <span class="iconfont iconclock"/>
                <span>{{response.display_time}}</span>
              </div>
              <div class="content-url-wrapper">
                <span class="iconfont iconcalendar"/>
                <span class="content-url url-copy" :data-clipboard-text="content" @click="copy">{{content}}</span>
              </div>
            </div>
            <div class="company-right flex-center">
              <img :src="response.company_logo_url || 'https://files.wondercv.com/icon/Artboard.png'"/>
            </div>
          </div>
        </div>
        <div class="container-middle" v-html="requirements"></div>
        <div class="desc_img" v-if="response.comp_recruit_info && response.comp_recruit_info.desc_img">
          <img :src="response.comp_recruit_info.desc_img.url" alt="">
        </div>
        <div class="container-bottom">
          <div class="header-title">
            <span class="march">热门校招</span>
            <div class="more" @click="toList">
              <span class="text">查看全部</span>
              <span class="iconfont iconchevron-right"/>
            </div>
          </div>
          <div class="listview">
            <div class="list-item" v-for="(item, index) in response.hot_jobs" :key="index" @click="_getDetail(item)">
              <span>{{item.comp_name}}</span>
              <span>{{item.display_time}}</span>
            </div>
          </div>
        </div>
        <div class="button-wrapper">
          <button @click="collection(response)">{{ response.job_is_liked ? '已收藏' : '收藏' }}</button>
          <button class="url-copy" :data-clipboard-text="content" @click="copy">网申投递</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
	import WNavBar from '../../components/global/w-navbar'
	import WLoading from '../../components/global/w-loading'
	import { envMixin, loginMixin } from '../../assets/js/mixin/global'
	import { campusMixin } from '../../assets/js/mixin/jobs'
	import { componentsMixin } from '../../assets/js/mixin/components'
	import Clipboard from 'clipboard'

	export default {
		name: 'campus',
		mixins: [ envMixin, campusMixin, componentsMixin, loginMixin ],
		data () {
			return {
				response: {},
				requirements: '',
				content: '',
				loadingShow: false
			}
		},
		async beforeRouteUpdate (to, from, next) {
			let token = to.params.token
			await this.getDetail(token)
			next()
		},
		async mounted () {
			this.changeNeedShareValue()
			await this.getDetail(this.$route.params.token)
			this.$route.meta.shareByWx(`${new Date().getFullYear()}届校招名企公司都在这里，名企校招内推机会`, {
				title: `收藏丨${ this.response.comp_recruit_info.comp_name }`,
				imgUrl: this.response.company_logo_url
			})
		},
		computed: {},
		watch: {},
		components: {
			WNavBar,
			WLoading
		},
		methods: {
			toBack () {
				if (this.isWxMini) {
					this.$wechat.miniProgram.reLaunch({
						url: `/pages/job-list/job-list?url=${ process.env.VUE_APP_HOST }/jobs/recommend`
					})
				} else if (window.history.length > 1) {
					this.$router.back()
				} else {
					window.location.href = '/jobs'
				}
			},
			toList () {
				this.routeReplace('/jobs/campus')
			},
			_getDetail (item) {
        let token = this.$route.params.token
        if (this.isWxMini) {
	        this.$db.ls.set('shareNeed', true)
          this.$wechat.miniProgram.navigateTo({
            url: `/pages/job-campus-detail/job-campus-detail?url=${ process.env.VUE_APP_HOST }/jobs/campus/${ item.token }&name=${ item.comp_name }`
          })
        } else {
          if (item.token !== token) {
            this.routeTo(`/jobs/campus/${ item.token }`)
          } else {
            window.scrollTo(0, 0)
          }
        }
			},
			async getDetail (token) {
				this.loadingShow = true
				let res = await this.$api.jobs.getCompInfo(token)
				this.response = res.data
				if (res.data.comp_recruit_info.desc)
					this.requirements = res.data.comp_recruit_info.desc
						.replace(/class="/gi, 'class="photo ')
						.replace(/<div/gi, '<div class="text-show"')
						.replace(/<p/gi, '<p class="text-show"')
						.replace(/style="/gi, '')
				this.content = res.data.comp_recruit_info.url || res.data.comp_recruit_info.email_addr
				this.loadingShow = false
			},
			copy () {
				let clipboard = new Clipboard('.url-copy')
				clipboard.on('success', e => {
					this.showToast('网申地址已复制')
					clipboard.destroy() // 释放内存
				})
			}
		}
	}
</script>

<style scoped lang="scss">
  @import '@/assets/scss/global/variable';
  @import '@/assets/scss/global/mixin';
  .detail-wrapper {
    min-height: 100vh;
    padding-top: 44px;
    box-sizing: border-box;
    /*padding-bottom: 65px;*/
    @include ipx-content-bottom(65px);
    .container {
      background-color: #f8f8fa;
      .container-top {
        padding: 25px 16px 23px 16px;
        background-color: $color-light;
        .title {
          color: $color-title;
          font-size: $font-size-large-x;
          margin-bottom: 12px;
          line-height: 26px;
        }
        .header-content {
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          .company-left {
            .cities,
            .desc {
              display: flex;
              flex-wrap: wrap;
              /* align-items: center; */
              margin-bottom: 12px;
              font-size: $font-size-medium;
              .city {
                margin-right: 5px;
                white-space: nowrap;
              }
              .iconfont {
                /* margin-right: 5px; */
                vertical-align: middle;
              }
            }
            .content-url-wrapper {
              display: flex;
              align-items: center;
              .iconcalendar {
                margin-right: 5px;
              }
              .content-url {
                display: block;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                color: $color-sky-blue;
                max-width: 220px;
                font-size: $font-size-medium;
              }
            }
          }
          .company-right {
            width: 72px;
            height: 72px;
            img {
              width: 72px;
              /*height: 72px;*/
              margin-bottom: -2px;
            }
          }
        }
      }
      .container-middle {
        padding: 16px;
        margin-top: 9px;
        overflow-x: scroll;
        background: $color-light;
        /deep/ img {
          // width: calc(100vw - 16px);
        }
        /deep/ * {
          line-height: 20px;
          color: $color-dark-gray;
          width: 100% !important;
        }
        .photo {
          // width: calc(100vw - 16px) !important;
        }
      }
      .desc_img {
        img {
          width: 100vw;
          display: block;
        }
      }
      .container-bottom {
        margin-top: 9px;
        background-color: $color-light;
        padding: 0 16px;
        .header-title {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 68px;
          .march {
            font-size: $font-size-medium-x;
            color: $color-title;
          }
          .more {
            display: flex;
            align-items: center;
            color: $color-light-gray;
            .text {
              font-size: $font-size-small;
            }
            .icon-font {
              font-weight: bold;
            }
          }
        }
        .listview {
          .list-item {
            height: 68px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            justify-content: center;
            border-bottom: 1px solid #f3f4f7;
            /*line-height: 20px;*/
            &:last-child {
              border-bottom: none;
            }
            span {
              max-width: 100vw;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              &:first-child {
                color: $color-title;
                font-size: $font-size-medium;
                margin-bottom: 10px;
                height: 16px;
                line-height: 16px;
              }
              &:last-child {
                color: $color-light-gray;
                font-size: $font-size-small;
              }
            }
          }
        }
      }

      .button-wrapper {
        position: fixed;
        bottom: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding-left: 16px;
        padding-right: 16px;
        @include ipx-footer(65px, 1px);
        box-sizing: border-box;
        box-shadow: 0 0 1px 0 #c2c2c2;
        background: $color-light;
        button {
          width: 47%;
          height: 44px;
          font-size: $font-size-medium;
          box-sizing: border-box;
          border-radius: 2px;
          outline: none;
          &:first-child {
            color: $color-theme;
            border: 1px solid $color-theme;
            background: transparent;
          }
          &:last-child {
            color: $color-light;
            background: $color-theme;
            border: none;
          }
        }
      }
    }
  }
</style>
